module.exports = __webpack_public_path__ + "static/media/261-kiribati.63848773.svg";